// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"6e42c3e1","277":"f62fa87c","355":"ed076007","453":"9e9da0d4","629":"6846304f","645":"9f47c445"}[chunkId] + ".chunk.js";
};